// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__1UZo7","validationTips":"StatementDescriptor_validationTips__3OGH7"};